/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_Autofill_HintInputs */

const cs_ruian_autofill_hint = /** @type {(inputs: Ruian_Autofill_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zelená = vyplněno, světle červená = prázdné, červená = neplatná hodnota.`)
};

const en_ruian_autofill_hint = /** @type {(inputs: Ruian_Autofill_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green = filled, light red = empty, red = invalid value.`)
};

/**
* | output |
* | --- |
* | "Green = filled, light red = empty, red = invalid value." |
*
* @param {Ruian_Autofill_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_autofill_hint = /** @type {((inputs?: Ruian_Autofill_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_Autofill_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_autofill_hint(inputs)
	return cs_ruian_autofill_hint(inputs)
});